import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { map } from 'rxjs';

import { NavigationMenuService } from '@shared/services/navigation-menu.service';

@Component({
  selector: 'app-promotion-side-bar',
  templateUrl: './promotion-side-bar.component.html',
  styleUrls: ['./promotion-side-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PromotionSideBarComponent {
  @Input()
  startDate: Date | null | undefined;

  @Input()
  endDate: Date | null | undefined;

  @Input() showGoToMap = false;
  @Output() goToMapClick = new EventEmitter<void>();

  mapLinkText$ = this.navigationService.isHelixLiteAvailable$.pipe(
    map((isHelixLite) =>
      isHelixLite ? 'Пункты Helix Lite с акцией' : 'Центры Хеликс с акцией'
    )
  );
  constructor(private navigationService: NavigationMenuService) {}

  formattedDate(date: Date): string {
    return date.toString().replace('г.', 'года');
  }

  goToMap(): void {
    this.goToMapClick.next();
  }
}
